<template>
  <div class="d-flex align-items-center justify-content-end">
    <b-button variant="outline-primary" class="cor_botao" :disabled="isDisabled" @click="downloadSpreadsheet()"
      v-b-tooltip.hover.bottom="tooltipText">
      <button id="download-import" class="button-icon text-custom-blue btn-icon" @keydown.enter="downloadSpreadsheet()"
        @keydown.space="downloadSpreadsheet()" aria-label="Download spreadsheet">
        <feather-icon icon="DownloadIcon" size="18" aria-hidden="true" />
      </button>
    </b-button>

    <b-modal id="add-new-item" no-close-on-esc no-close-on-backdrop hide-header hide-footer centered
      v-model="showModal">
      <div v-if="showModal" class="d-flex justify-content-center my-3">
        <output class="spinner-border text-custom-blue">
          <span class="sr-only">Loading...</span>
        </output>
      </div>
      <h2 class="text-center">Estamos processando</h2>
    </b-modal>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import moment from "moment/moment";

export default {
  name: "ButtonDownloadSpreadsheet",
  components: { BButton },
  props: {
    type: {
      type: String,
      required: true
    },
    endpointUsuarioEmpresa: {
      type: String,
      required: false,
      default: null
    },
    parameters: {
      type: Object,
      required: true
    },
    isEmpty: {
      type: Boolean,
      default: true
    },
    loadingData: {
      type: Boolean,
      default: true
    },
    tooltipText: {
      type: String
    },
    size: {
      type: Number
    },
    idGrupo: {
      type: Number
    },
    route: {
      type: String
    },
  },
  data() {
    return {
      showModal: false,
      activeButtonSheet: false,
      endpoint: null,
      filename: null,
    }
  },
  beforeMount() {
    switch (this.type) {
      case 'EstoqueFisico':
        this.endpoint = this.$api.lote()
        this.filename = 'estoque-fisico.xlsx'
        break
      case 'Entrada':
        this.endpoint = this.$api.notaFiscal()
        this.filename = 'entrada-vacinas.xlsx'
        break
      case 'Transferencia':
        this.endpoint = this.$api.movimentacao()
        this.filename = 'transferencia.xlsx'
        break
      case 'AjusteEstoque':
        this.endpoint = this.$api.movimentacao()
        this.filename = 'ajuste-estoque.xlsx'
        break
      case 'Lote':
        this.endpoint = this.$api.listarLote()
        this.filename = 'lote.xlsx'
        break
      case 'CampanhasRegionais':
        this.endpoint = this.$api.campanha()
        this.filename = 'campanhas-regionais.xlsx'
        break
      case 'CampanhasNacionais':
        this.endpoint = this.$api.campanhaNacional()
        this.filename = 'lista-campanhas-nacional.xlsx'
        break
      case 'ListaGrupoEmpresas':
        this.endpoint = this.$api.getAndPostGrupo()
        this.filename = 'lista-grupos-empresas.xlsx'
        break
      case 'VisualizarGrupoEmpresas':
        this.endpoint = this.$api.getAndPutAndDeleteGrupo(this.idGrupo)
        this.filename = 'grupo-empresas.xlsx'
        break
      case 'VisualizarGrupoNegocios':
        this.endpoint = this.$api.getAndPutAndDeleteGrupo(this.idGrupo)
        this.filename = 'grupo-empresas-negocios.xlsx'
        break
      case 'AdesaoNacional':
        this.endpoint = this.$api.adesaoNacionalGrupos()
        this.filename = 'lista-adesao-nacional.xlsx'
        break
      case 'Unidade':
        this.endpoint = this.$api.unidade()
        this.filename = 'lista-unidades-operacionais.xlsx'
        break
      case 'UsuariosSesi':
        this.endpoint = this.$api.usuarioAdmin()
        this.filename = 'lista-users-sesi.xlsx'
        break
      case 'ListaDepartamento':
        this.endpoint = this.$api.departamento()
        this.filename = 'lista-departamento-regional.xlsx'
        break
      case 'PontoAtendimento':
        this.endpoint = this.$api.listOrSavePontoAtendimento()
        this.filename = 'lista-ponto-atendimento.xlsx'
        break
      case 'UsuarioEmpresa':
        this.endpoint = this.endpointUsuarioEmpresa
        this.filename = 'lista-users-empresas.xlsx'
        break
      case 'Doencas':
        this.endpoint = this.$api.saveAndGetDoenca()
        this.filename = 'lista-doencas.xlsx'
        break
      case 'Avisos':
        this.endpoint = this.$api.saveAndGetNotificacao()
        this.filename = 'lista-avisos.xlsx'
        break
      case 'Vacinas':
        this.endpoint = this.$api.saveAndGetVacina()
        this.filename = 'lista-vacinas.xlsx'
        break
      case 'Doses':
        this.endpoint = this.$api.getDose()
        this.filename = 'lista-dose.xlsx'
        break
      case 'Ajuda':
        this.endpoint = this.$api.ajuda()
        this.filename = 'lista-ajuda.xlsx'
        break
      case 'AdesaoRegional':
        this.endpoint = this.route ?? this.$api.adesao()
        this.filename = 'lista-adesao-regional.xlsx'
        break
      case 'Agendamentos':
        this.endpoint = this.$api.getAndPostAgendamento()
        this.filename = 'lista-agendamentos.xlsx'
        break
      default:
        this.endpoint = ''
    }
  },
  methods: {
    async downloadSpreadsheet() {
      this.showModal = true

      this.parameters.porPagina = this.size
      this.parameters.tamanho = this.size
      this.parameters.pagina = 1
      this.parameters.page = 1

      const consult = await this.$http.get(this.endpoint, { params: this.parameters })
        .finally(() => {
          this.showModal = false
        });

      const dados = consult?.data?.data ?? consult?.data ?? []
      this.geraDownload(dados)
    },
    geraDownload(data) {
      let items;
      switch (this.type) {
        case 'EstoqueFisico':
          items = this.formataDadosEstoqueFisico(data);
          break
        case 'Entrada':
          items = this.formataDadosEntrada(data);
          break
        case 'Transferencia':
          items = this.formataDadosTransferencia(data);
          break
        case 'AjusteEstoque':
          items = this.formataDadosAjusteEstoque(data);
          break
        case 'Lote':
          items = this.formataDadosLote(data);
          break
        case 'CampanhasRegionais':
          items = this.formataDadosCampanhasRegionais(data);
          break
        case 'CampanhasNacionais':
          items = this.formataDadosCampanhasNacionais(data);
          break
        case 'ListaGrupoEmpresas':
          items = this.formataDadosGrupoEmpresas(data);
          break
        case 'VisualizarGrupoEmpresas':
          items = this.formataDadosVisualizarGrupoEmpresas(data);
          break
        case 'VisualizarGrupoNegocios':
          items = this.formataDadosVisualizarGrupoNegocios(data);
          break
        case 'AdesaoNacional':
          items = this.formataDadosAdesaoNacional(data);
          break
        case 'Unidade':
          items = this.formataDadosUnidade(data);
          break
        case 'UsuariosSesi':
          items = this.formataDadosUsuarioSesi(data);
          break
        case 'ListaDepartamento':
          items = this.formataDadosListaDepartamento(data);
          break
        case 'PontoAtendimento':
          items = this.formataDadosPontoAtendimento(data);
          break
        case 'UsuarioEmpresa':
          items = this.formataDadosUsuarioEmpresa(data);
          break
        case 'Doencas':
          items = this.formataDadosDoencas(data);
          break
        case 'Avisos':
          items = this.formataDadosAviso(data);
          break
        case 'Vacinas':
          items = this.formataDadosVacinas(data);
          break
        case 'Doses':
          items = this.formataDadosDose(data);
          break
        case 'Ajuda':
          items = this.formataDadosAjuda(data);
          break
        case 'AdesaoRegional':
          items = this.formataDadosAdesaoRegional(data);
          break
        case 'Agendamentos':
          items = this.formataDadosAgendamentos(data);
          break
        default:
          items = []
      }
      this.$helpers.downloadArchiveXlsx(items, this.filename)
    },

    formataDadosEstoqueFisico(dados) {
      return dados.map(item => ({
        'LOTE': item.numero_lote,
        'VACINA': item.nome_tecnico_vacina,
        'VALIDADE': this.formataData(item.validade),
        'FABRICANTE': item.descricao_fabricante,
        'DOSE': item.descricao_frasco,
        'QTD DOSES': item.saldo,
        'UNIDADE OPERACIONAL': item.descricao_unidade,
      }));
    },

    formataDadosEntrada(dados) {
      return dados.map(item => ({
        'Nº Nota Fiscal': item.numero,
        'Data da Emissão': this.formataData(item.emissao),
        'Data do Lançamento': this.formataData(item.lancamento),
        'Fornecedor': item.fornecedor,
        'Lote': item.numero_lote,
        'Unidade Operacional': item.unidade,
        'QTD Doses': item.quantidade,
      }));
    },

    formataDadosTransferencia(dados) {
      return dados.map(item => ({
        'Transferência': '#' + item.codigo,
        'Nota Fiscal': item.numero_nota_fiscal,
        'Status': item.situacao,
        'Lote': item.itens[0].lote_unidade_origem.lote.numero_lote,
        'Última Atualização': item.ultima_alteracao ? this.formataData(item.ultima_alteracao) : "-",
        'QTD Doses': item.itens[0].quantidade,
        'Origem': item.descricao_unidade_origem,
        'Destino': item.descricao_unidade_destino,
      }));
    },

    formataDadosAjusteEstoque(dados) {
      return dados.map(item => ({
        'Ajuste': '#' + item.codigo,
        'Tipo': item.tipo_movimentacao,
        'Data do Ajuste': this.formataData(item.ultima_alteracao),
        'Lote': item.itens[0].lote_unidade_origem.lote.numero_lote,
        'Validade': this.formataData(item.itens[0].lote_unidade_origem.lote.validade),
        'QTD Doses': item.itens[0].quantidade,
        'Unidade Operacional': item.descricao_unidade_origem,
      }));
    },

    formataDadosLote(dados) {
      return dados.map(item => ({
        'LOTE': item.numero_lote,
        'VACINA': item.vacina.nome_tecnico,
        'VALIDADE': this.formataData(item.validade),
        'FABRICANTE': item.fabricante.descricao,
        'DOSE': item.frasco.descricao,
        'STATUS': item.ativo ? 'Ativo' : 'Inativo',
      }));
    },

    formataDadosUnidade(dados) {
      return dados.map(item => ({
        'DEPARTAMENTO REGIONAL': item.descricao_departamento,
        'UNIDADE OPERACIONAL': item.descricao_unidade,
        'CNES': item.cnes,
        'CIDADE': item.descricao_cidade,
        'TIPO': item.tipo,
        'STATUS': item.ativo === true ? 'Ativo' : 'Inativo',
      }));
    },

    formataDadosUsuarioSesi(dados) {
      return dados.map(item => ({
        'NOME': item.nome,
        'E-MAIL': item.email,
        'DEPARTAMENTO': item.departamento_nome,
        'STATUS': item.ativo === true ? 'Ativo' : 'Inativo',
        'VACINADOR': item.documento !== null ? 'Sim' : 'Não',
        'ATUA COM EMPRESAS DE BASE NACIONAL': item.tipo_atuacao.length > 0 ? 'Sim' : 'Não',
        'PERFIL': item.perfil[0].descricao,
      }));
    },

    formataDadosListaDepartamento(dados) {
      return dados.map(item => ({
        'DEPARTAMENTO REGIONAL': item.descricao,
        'UF - ESTADO': item.estado,
        'STATUS': item.ativo === true ? 'Ativo' : 'Inativo',
      }));
    },

    formataDadosPontoAtendimento(dados) {
      return dados.map(item => ({
        'PONTOS DE ATENDIMENTO': item.descricao,
        'CIDADE': item.nome_cidade,
        'STATUS': item.ativo ? 'Ativo' : 'Inativo',
      }));
    },

    formataDadosUsuarioEmpresa(dados) {
      return dados.map(item => ({
        'NOME': item.nome,
        'E-MAIL': item.email,
        'STATUS': item.ativo ? 'Ativo' : 'Inativo',
      }));
    },

    formataDadosCampanhasRegionais(dados) {
      return dados.map(item => ({
        'NOME': item.campanha_descricao,
        'PERÍODO': this.cronogramaCampanha(item.campanha_situacao, item.inicio_campanha, item.termino_campanha),
        'STATUS': item.campanha_situacao,
        'DEPARTAMENTO REGIONAL': item.departamento_descricao
      }));
    },

    formataDadosCampanhasNacionais(dados) {
      return dados.map(item => ({
        'NOME': item.descricao,
        'PERÍODO': this.cronogramaCampanha('Nacional', item.inicio, item.termino),
      }));
    },

    formataDadosGrupoEmpresas(dados) {
      return dados.map(item => ({
        'GRUPO': item.descricao,
        'ADMINISTRATIVO E FINANCEIRO': item.descricao_departamento_administrativo,
        'RELACIONAMENTO': item.descricao_departamento_relacionamento,
        'TÉCNICO': item.descricao_departamento_tecnico
      }));
    },

    formataDadosVisualizarGrupoEmpresas(dados) {
      return dados.empresa_operador.map(item => ({
        'CNPJ | CPF': item.documento_formatado,
        'RAZÃO SOCIAL': item.razao_social,
        'NOME EMPRESA': item.nome_empresa,
        'CIDADE': item.grupo_operadores[0].nome_cidade,
        'UF': item.grupo_operadores[0].uf,
        'STATUS': item.situacao_cadastro
      }));
    },

    formataDadosVisualizarGrupoNegocios(dados) {
      return dados.grupo_negocio.map(item => ({
        'GRUPO': dados.descricao,
        'NOME NEGÓCIO': item.descricao,
        'NÚMERO DE EMPRESAS VINCULADAS': item.quantidade_empresas_vinculadas,
        'DATA DE CRIAÇÃO': item.data_criacao,
        'ÚLTIMA ATUALIZAÇÃO': item.ultimaAlteracao ? item.ultimaAlteracao : "-",
      }));
    },

    formataDadosAdesaoNacional(dados) {
      return dados.map(item => ({
        'GRUPO': item.descricao_grupo,
        'CAMPANHA NACIONAL': item.descricao_campanha,
        'OPERADOR': item.sigla,
        'DOSES DISTRIBUÍDAS': item.doses_distribuidas,
        'DOSES DISPONÍVEIS': item.doses_disponiveis,
        'STATUS': item.situacao
      }));
    },

    formataDadosVacinas(dados) {
      return dados.map(item => ({
        'VACINA': item.nome_tecnico_vacina,
        'DOENÇAS RELACIONADAS': Array.isArray(item.doencas) ? item.doencas.map(doenca => doenca.nome_tecnico).join(', ') : '',
        'STATUS': item.ativo ? 'Ativo' : 'Inativo',
      }));
    },

    formataDadosDose(dados) {
      return dados.map(item => ({
        'DOSE': item.descricao,
        'CÓDIGO': item.br_dose,
        'STATUS': item.ativo ? 'Ativo' : 'Inativo',
      }));
    },

    formataDadosDoencas(dados) {
      return dados.map(item => ({
        'DOENÇAS': item.nome_tecnico_doenca,
        'VACINAS RELACIONADAS': Array.isArray(item.vacinas) ? item.vacinas.map(vacina => vacina.nome_tecnico).join(', ') : '',
        'STATUS': item.ativo ? 'Ativo' : 'Inativo'
      }))
    },

    formataDadosAviso(dados) {
      return dados.map(item => ({
        'TÍTULO DO AVISO': item.titulo,
        'PERFIS': Array.isArray(item.perfis) ? item.perfis.map(perfil => perfil.descricao).join(', ') : '',
        'DATA LIMITE': this.formataData(item.vigencia_final),
        'STATUS': this.resolveStatus(item)
      }))
    },

    formataDadosAjuda(dados) {
      return dados.map(item => ({
        'TÓPICO DE AJUDA': item.topico,
        'CATEGORIA': item.categoria,
        'ATUALIZADO': item.atualizado,
        'STATUS': item.ativo ? 'Ativo' : 'Inativo'
      }))
    },

    formataDadosAdesaoRegional(dados) {
      return dados.map(item => ({
        'PEDIDO': '#'+item.numero_pedido,
        'CAMPANHA': item.nome_campanha,
        'REALIZADO POR': item.realizado_por,
        'INICIADO': this.formataDataHora(item.data_processamento),
        'CNPJ | CPF': this.formatCnpj(item.cnpj_cpf_empresa),
        'NOME FANTASIA': item.nome_empresa,
        'RAZAO SOCIAL': item.razao_social,
        'VACINA': (Array.isArray(item.vacinas) ? item.vacinas : JSON.parse(item.vacinas || '[]')).map(v => v.nome_tecnico).join(', '),
        'CATEGORIA': (Array.isArray(item.categorias) ? item.categorias : JSON.parse(item.categorias || '[]')).map(v => v.nome_categoria).join(', '),
        'QTD DE DOSES': item.total_doses,
        'STATUS': item.pedido_situacao ?? item.situacao,
      }));
    },

    formataDadosAgendamentos(dados) {
      return dados.map(item => ({
        'CNPJ': this.formatCnpj(item.cnpj),
        'RAZÃO SOCIAL': item.razao_social,
        'NOME FANTASIA': item.nome_fantasia,
        'UNIDADE OPERACIONAL': item.unidade_descricao,
        'DATA INICIAL': item.data_aplicacao ? this.formataData(item.data_aplicacao) : '',
        'DATA FINAL': item.data_final_aplicacao ? this.formataData(item.data_final_aplicacao) : '',
        'PERÍODOS': this.periodosAgendamento(item),
        'DOSES PREVISTAS': item.agendamento_vacina.length ? item.dose_prevista : 0,
        'DOSES APLICADAS': item.agendamento_vacina.length ? item.quantidade_dose_aplicada : 0,
        'STATUS': item.situacao,
      }))
    },

    formataData(data) {
      return moment(data).format('DD/MM/YYYY');
    },

    formatCnpj(cnpj) {
      return this.$options.filters.formataCpfCnpj(cnpj);
    },

    formataDataHora(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },

    cronogramaCampanha(situacao, inicioCampanha, terminoCampanha) {
      if (!situacao || situacao === 'Rascunho') {
        return '-'
      }

      const formatoData = situacao === 'Nacional' ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm'

      const inicioCampanhaAux = inicioCampanha ? moment(inicioCampanha).format(formatoData) : ''
      const terminoCampanhaAux = terminoCampanha ? moment(terminoCampanha).format(formatoData) : ''

      return `${inicioCampanhaAux} - ${terminoCampanhaAux}`
    },

    resolveStatus(item) {
      if (!item.ativo) {
        return 'Inativado'
      }

      if (!moment(this.today).isAfter(item.vigencia_final)) {
        return 'Ativo'
      }

      return 'Expirado'
    },

    periodosAgendamento(item) {
      if (item.periodo) {
        return item.periodo
      }

      if (
          Array.isArray(item.agendamento_periodos) &&
          item.agendamento_periodos.length
      ) {
        return item.agendamento_periodos
            .map(p => p.descricao)
            .join('/')
      }

      return ''
    }
  },
  computed: {
    isDisabled() {
      return this.isEmpty || this.showModal
    }
  },
  watch: {
    endpointUsuarioEmpresa(newVal) {
      if (this.type === 'UsuarioEmpresa') {
        this.endpoint = newVal
      }
    }
  }
}
</script>
<style scoped lang="scss">
.cor_botao {
  color: #2772C0 !important;
  border: 1px solid #2772C0 !important;
}

.button-icon {
  background: none;
  border: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
}

.button-icon:focus {
  outline: none;
}

button.disabled {
  cursor: not-allowed;
  background-color: transparent;
  border-color: #6e6b7b !important;

  * {
    cursor: not-allowed;
    color: #6e6b7b !important;
  }
}
</style>
